import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { Router, RouteReuseStrategy } from '@angular/router';
import { HttpClientModule, HttpClient, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AnimationController, IonicModule, IonicRouteStrategy, mdTransitionAnimation } from '@ionic/angular';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { StartupService } from './_services/startup.service';
import { AppPreloadingStrategyService } from './preloading-strategy.service';
import { JwtInterceptor } from './_helpers/jwt.interceptor';
import { AuthenticationService } from './_services/authentication.service';
import { appInitializer } from './_helpers/app.initializer';
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { MissingTranslationHandler, MissingTranslationHandlerParams } from '@ngx-translate/core';
import { StateService } from './_services/state.service';
import { ApiService } from './_services/api.service';
import { EventsService } from './_services/events.service';
import { SharedModule } from './modules/shared.module';
import { HelperService } from './_helpers/helper.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { UserService } from './_services/user.service';
import { ErrorInterceptor } from './_helpers/error.interceptor';
import { InAppBrowser } from '@awesome-cordova-plugins/in-app-browser/ngx';
import { SettingsService } from './_services/settings.service';
import { GlobalErrorHandler } from './_helpers/global-error.handler';
import { CustomTranslateLoader } from './_helpers/translate.loader';
import { DebugService } from './_services/debug.service';
import { PurchaseService } from './_services/purchase.service';
import { GamesService } from './_services/games.service';

export class MyMissingTranslationHandler implements MissingTranslationHandler {
  handle(params: MissingTranslationHandlerParams) {
    return params.key;
  }
}

export function startupServiceFactory(
  startupService: StartupService
): Function {
  return startupService.startup;
}
@NgModule({
    declarations: [
        AppComponent
    ],
    imports: [
        SharedModule.forRoot(),
        BrowserModule,
        BrowserAnimationsModule,
        IonicModule.forRoot({
            rippleEffect: false,
            spinner: 'dots',
            refreshingSpinner: 'dots',
            infiniteLoadingSpinner: 'dots',
            mode: 'ios',
            swipeBackEnabled: true,
            innerHTMLTemplatesEnabled: true,
            // navAnimation: _ => new AnimationController().create()
            // navAnimation: mdTransitionAnimation
        }),
        HttpClientModule,
        AppRoutingModule,
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useClass: CustomTranslateLoader,
                deps: [HttpClient]
            },
            missingTranslationHandler: {
                provide: MissingTranslationHandler,
                useClass: MyMissingTranslationHandler
            }
        })
    ],
    providers: [
        AppPreloadingStrategyService,
        AuthenticationService,
        StartupService,
        DebugService,
        EventsService,
        StateService,
        UserService,
        ApiService,
        HelperService,
        SettingsService,
        GamesService,
        PurchaseService,
        InAppBrowser,
        { provide: ErrorHandler, useClass: GlobalErrorHandler },
        {
            provide: APP_INITIALIZER,
            useFactory: appInitializer,
            multi: true,
            deps: [AuthenticationService]
        },
        { provide: HTTP_INTERCEPTORS, useClass: JwtInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
        { provide: RouteReuseStrategy, useClass: IonicRouteStrategy }
    ],
    bootstrap: [AppComponent],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AppModule {}
